import { createElement, forwardRef } from 'react';
import { TextProps } from './types';
import { BaseText } from './__internal__';

export const Text = forwardRef<HTMLSpanElement, TextProps>((props, ref) => (
  <BaseText {...props} ref={ref} />
));
